// tableIgnoredFields.js

const TABLE_IGNORED_FIELD_KEYS = new Set(['cover']);

const normalizeFieldKey = (fieldKey) => String(fieldKey || '').trim();

export const isTableIgnoredFieldKey = (fieldKey) => (
    TABLE_IGNORED_FIELD_KEYS.has(normalizeFieldKey(fieldKey))
);

export const filterTableIgnoredFields = (fields = []) => (
    fields.filter((field) => {
        const key = field?.name || field?.key;
        return key && !isTableIgnoredFieldKey(key);
    })
);

export const filterTableIgnoredKeys = (keys = []) => (
    keys.filter((key) => key && !isTableIgnoredFieldKey(key))
);

export { TABLE_IGNORED_FIELD_KEYS };
